class WJSON {
	
	encode(item)
	{
		return JSON.stringify(item)
	}
	decode(str)
	{
		try 
		{
		    return JSON.parse(str)
		}
		catch(err) 
		{
			console.error('WJSON DECODE ERROR', err)
			return {}
		}
	}

}
export default new WJSON();


// WEBPACK FOOTER //
// ./src/helpers/json.js